<template>
  <component :is="currentComponent" />
</template>

<script>
import DzDetail from './DzDetail';
import CommonDetail from './CommonDetail';
export default {
  components: {
    DzDetail,
    CommonDetail
  },
  data() {
    return {
      currentComponent: 'DzDetail'
    }
  },
  created() {
    this.currentComponent = this.mixinUserInfo.platformType === 1 ? 'DzDetail' : 'CommonDetail';
  }
}
</script>





